import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { CategoryService } from '@services/category.service';
import { SearchService } from '@services/search.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { CategoryRelatedService } from '@services/category-related.service';
import { Helper } from '@category/helper';
import { MapsAPILoader } from "@agm/core";
import { uuid } from 'uuidv4';
import * as _ from 'lodash';
import { google } from "google-maps";
declare var google: google;
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
@Component({
  selector: 'app-cproduct',
  templateUrl: './cproduct.component.html',
  styleUrls: ['./cproduct.component.sass']
})
export class CproductComponent implements OnInit {
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true
  };
  relatedProductIds: any = [];
  appCreateForm: FormGroup;
  inventoryPolicy_list: any = []
  params: any = [];
  response: any = [];
  product_include: string = "";
  error: any = { categoryJson: '', description: '', upc: '', isbn: '', ean: '', name: '', currency: '', delivery: '', category: '', model: '', brand: '', discountValue: '', quantityToNotify: '', quantity: '', warranty: '', sku: '', basePrice: '' };
  btn_process = false;
  user_refresh: any = [];
  trackInventory_content = false;
  status_list: any = [];
  weightUnit_list: any = [];
  pathToMedia: any = {};
  image_paths: any = [];
  discountType_list: any = [];
  ageGroup_list: any = [];
  standards_list: any = []
  gender_list: any = [];
  sizeUnit_list: any = [];
  selected_category = "";
  condition_list: any = [];
  status_txt = '';
  color = "";
  application = "";
  component = "";
  delivery_list: any = []
  deliveryend_list: any = [];
  deliverystart_list: any = [];
  availability_list: any = []
  brand_list: any = [];
  related_data: any = [];
  constructor(private _relatedService: CategoryRelatedService, private _viewService: ViewService, private ngZone: NgZone, private MapsAPILoader: MapsAPILoader, private _searchService: SearchService, private _categoryService: CategoryService, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SEC;
    this.application = "product";
    this.appCreateForm = this.fb.group({
      status: [],
      name: [],
      description: [],
      availability: [],
      delivered: ['standard'],
      deliveryEnd: [],
      deliveryStart: [],
      inventoryPolicy: ['Stop selling when sold out.'],
      url: [],
      delivery: [],
      discountType: [],
      weightUnit: [],
      productLength: [],
      brand: [],
      quantity: [],
      includes: new FormArray([]),
      customProperties: new FormArray([]),
      quantityToNotify: [],
      manufacturerPartNumber: [],
      sizeUnit: [],
      gender: [],
      ageGroup: [],
      ean: [],
      upc: [],
      height: [],
      width: [],
      model: [],
      additionalShippingCharges: [],
      color: [],
      size: [],
      weight: [],
      sku: [],
      currency: [this._global.getCurrency()],
      basePrice: [0],
      discountValue: [],
      isbn: [],
      chargeTaxes: [],
      trackInventorys: [],
      warranty: [],
      notes: [],
      condition: []
    });
    this.appCreateForm.get('currency').disable();

    let f = {
      'component': this.component,
      'application': this.application
    };
    this._formdataService.common(f, 'listStatusTypes').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.status_list = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    this._formdataService.common(f, 'discountTypes').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.discountType_list = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    this._formdataService.common(f, 'numbers').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.deliverystart_list = this._global.getVal(data, 'response', '');
          this.deliveryend_list = this._global.getVal(data, 'response', '');

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    this._formdataService.common(f, 'deliveryStandards').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.standards_list = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    this._formdataService.common(f, 'delivery').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.delivery_list = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    this._formdataService.common(f, 'availability').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.availability_list = this._global.getVal(data, 'response', '');

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    this._formdataService.common(f, 'condition').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.condition_list = this._global.getVal(data, 'response', '');

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    this._formdataService.common(f, 'lengthUnits').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.sizeUnit_list = this._global.getVal(data, 'response', '');

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    this._formdataService.common(f, 'productGender').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.gender_list = this._global.getVal(data, 'response', '');

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    this._formdataService.common(f, 'ageGroups').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.ageGroup_list = this._global.getVal(data, 'response', '');

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    this._formdataService.common(f, 'weightUnits').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.weightUnit_list = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    this._formdataService.common(f, 'inventoryPolicy').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.inventoryPolicy_list = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    let THIS = this;
    let p = {
      'component': this.component,
      'application': 'category',
      'categoryType': this.application
    };
    this._categoryService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          let result = this._global.getVal(data, 'response', '');
          CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", '', this.application, true);
          CATEGORYEDIT.init(result, '#entity_category', false, "entityTree", '', this.application, true);
          $("div#entity_category a").click(function (e) {
            THIS.related_data = [];
            let id = ($(this).attr("id")).split("_");
            let p = {
              'component': THIS.component,
              'application': THIS.application,
              categoryId: id[0]
            };

            THIS._relatedService.related(p).subscribe(
              data => {
                if (!_.isEmpty(THIS._global.getVal(data, 'response', ''))) {
                  let result = THIS._global.getVal(data, 'response', '');
                  THIS.related_data = result;
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
          });
          $("div#" + this.application + "_category").click(function (e) {
            var $target = $(e.target);
            if ($target.attr("id") === "categoryCheck") {
              //  let result = Helper.getCategoryChecboxValues("categoryCheck", '');
              THIS.selected_category = Helper.categoryJsonText("categoryCheck");
            }
          });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    let s = {
      'component': this.component,
      'application': 'brand',
      'sortOrder': 'desc',
      'sortString': 'createdTime',
      "start": 0,
      "rows": 100
    };
    this._searchService.application(s).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.brand_list = this._global.getVal(data, 'response.docs', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }

  ngOnInit() {


  }
  returnZero() {
    return 0
  }
  removeImg(id) {
    if (this.image_paths[0]) {
      this.pathToMedia = this._global.removePathToMediaImage(this.pathToMedia, id);
      this.image_paths = [];
      this.image_paths.push(this.pathToMedia);
    }
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }
  public onUploadSuccess(args: any): void {
    let res = JSON.parse(args[1]);
    this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);
    this.image_paths = [];
    this.image_paths.push(this.pathToMedia);
  }
  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'photo', '');
  }
  public cancel() {
    this.router.navigate(['/my/' + this.application]);
  }

  save() {
    this.error = { categoryJson: '', upc: '', isbn: '', ean: '', name: '', currency: '', delivery: '', category: '', model: '', brand: '', discountValue: '', quantityToNotify: '', quantity: '', warranty: '', sku: '', basePrice: '' };
    let includes = {}; let customProperties = {};
    this.btn_process = true;
    let r = this.appCreateForm.value;
    let p = this._global.generateParams(r, ['includes','customProperties']);
    p['component'] = this.component;
    p['application'] = this.application;
    p = this._global.paramsRemoveNull(p);
    p['categoryJson'] = Helper.getCategoryChecboxValues("categoryCheck", '');
    Object.entries(this.appCreateForm.value['includes']).forEach(([key, value]) => {
      if (value) {
        includes[uuid()] = value;
      }
    });
    p['includes'] = JSON.stringify(includes);
    let custom = [];
    Object.entries(this.appCreateForm.value['customProperties']).forEach(([key, value]) => {
      if (value['name']) {
        let result = {};
        result["name"] = value['name'];
        result["values"] = value['value'];
        custom.push(result);
      }
    });
    p['currency'] = this._global.getCurrency();
    p['customProperties'] = JSON.stringify(custom);
    p['pathToMedia'] = JSON.stringify(this.pathToMedia);
    if (this.relatedProductIds.length > 0) {
      let rp = [];
      Object.entries(this.relatedProductIds).forEach(([key, value]) => {
        rp.push(value['value']);
      });
      p['relatedProductIds'] = rp.join(",");
    }
    this._saveService.app(p).subscribe(
      data => {
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ severity: severity, message: message });
          this.router.navigate(['/my/' + this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'error';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ severity: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  addItem() {
    const control = this.fb.control('');
    (this.appCreateForm.controls.includes as FormArray).push(control);
  }
  addSpecification() {
    const control = this.fb.group({
      name: [],
      value: []
    });
    (this.appCreateForm.get('customProperties') as FormArray).push(control);

  }
  chooseRelated(obj) {
    let r = this.relatedProductIds.find(x => x.value == obj.value);
    if (!r) {
      this.relatedProductIds.push(obj);
    }

  }
  removeRelated(obj) {
    this.relatedProductIds = this.relatedProductIds.filter(item => item.value != obj.value);
  }
  trackInventory(event) {
    console.log("event", this.appCreateForm.get("trackInventorys").value)
    this.trackInventory_content = false;
    if (this.appCreateForm.get("trackInventorys").value == true) {
      this.trackInventory_content = true;
    }
  }

}
